<ng-template #initLoadingTemplate>
    <app-loading-page></app-loading-page>
</ng-template>
